import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card } from "@libs/rubick";
import { ApiKeyFilter } from "./ApiKeyFilter";
import { DateRangeSelector } from "./DateRangeSelector";
import { ViewTypeToggle } from "./ViewTypeToggle";
import { USAGE_VIEW_TYPES } from "@/constants/usage";
export const UsageFilters = ({ filters, onViewTypeChange, onDateChange, onDateRangeChange, onApiKeyChange, productCode, includeInactiveApiKeys = false, customerIdOverride })=>{
    return /*#__PURE__*/ _jsx(Card, {
        variant: "bordered",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "grid grid-cols-1 gap-4 lg:grid-cols-4",
            children: [
                /*#__PURE__*/ _jsx(ViewTypeToggle, {
                    viewType: filters.viewType,
                    onChange: onViewTypeChange
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: filters.viewType === USAGE_VIEW_TYPES.DAILY ? "lg:col-span-2" : "",
                    children: /*#__PURE__*/ _jsx(DateRangeSelector, {
                        filters: filters,
                        onDateChange: onDateChange,
                        onDateRangeChange: onDateRangeChange
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: filters.viewType === USAGE_VIEW_TYPES.HOURLY ? "lg:col-span-2" : "",
                    children: /*#__PURE__*/ _jsx(ApiKeyFilter, {
                        selectedApiKey: filters.selectedApiKey,
                        onChange: onApiKeyChange,
                        productCode: productCode,
                        includeInactive: includeInactiveApiKeys,
                        customerIdOverride: customerIdOverride
                    })
                })
            ]
        })
    });
};
